import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css'
import '../assets/custom.css'
Vue.use(Vuetify, {
    iconfont: 'mdi'
});

export default new Vuetify({
    icons: {
        iconfont: 'md',
    },
    theme: {
        themes: {
            light: {
                primary: '#00897B',
                secondary: '#FFB74D',
                accent: '#1DE9B6',
                error: '#b71c1c'
            }
        }
    }
});